import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { YtbService } from '../ytb.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SocketService } from '../socket.service';
import { SearchService } from '../search.service';
declare var $: any;
declare var ResizeObserver: any;

declare global {
  interface Window {
    app?: any;
  }
}

const bulletDuration = 10; // seconds
let lineYposTracker = 0;

@Component({
  selector: 'app-caption-man',
  templateUrl: './caption-man.component.html',
  styleUrls: ['./caption-man.component.less'],
})
export class CaptionManComponent implements OnInit {
  captionTracks = [];
  captionLines2 = [];
  originalCaptionLines2 = [];
  selectedTracks = [];
  trackName = '';

  lines = [];
  captionLines = [];
  commentLines = [];

  noCaptions = false;
  currentTab = localStorage.getItem('last-man-tab') || 'CAPTION';
  videoInfo = null;

  username = (() => {
    try {
      if (window.top !== window.self && window.top.app.user.uid) {
        return window.top.app.user.username;
      }
      return '';
    } catch (error) {
      return '';
    }
  })();
  userslug = (() => {
    try {
      if (window.top !== window.self && window.top.app.user.uid) {
        return window.top.app.user.userslug;
      }
      return '';
    } catch (error) {
      return '';
    }
  })();
  userPicture = (() => {
    try {
      if (window.top !== window.self && window.top.app.user.uid) {
        return window.top.app.user.picture;
      }
      return '';
    } catch (error) {
      return '';
    }
  })();
  invalidUsername = false;

  commentCtrl = new FormControl();
  currentComment = '';

  repeatA: number;
  repeatB: number;

  currentVid = '';
  currentTime = 0;
  currentLine = null;
  currentLineNum = 0;
  currentLineTimer = null;
  defaultLanguages = [];
  loading = false;

  Math = Math;

  error = null;

  currentLineTop = 0;
  settings = {
    darkMode:
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches,
    timestamp: true,
    bulletScreen: true,
    fontSize: 16,
    autoScrollMode: 'page',
  };

  openShareTimer = null;
  openedShareBefore = false;
  playerHeight = 0;

  asciiCat = '';
  hasDictionariezInstalled = false;

  searchText = '';
  searchLanguageName = '';
  isSearching = false;

  bulletTimer = null;

  constructor(
    private ytb: YtbService,
    private cd: ChangeDetectorRef,
    private socketService: SocketService,
    private searchService: SearchService
  ) {
    if (localStorage.getItem('captionz-settings'))
      this.settings = Object.assign(
        this.settings,
        JSON.parse(localStorage.getItem('captionz-settings'))
      );
    document.body.classList.add(
      this.settings.darkMode ? 'dark-theme' : 'light-theme'
    );
  }

  reset() {
    this.lines = [];
    this.captionLines = [];
    this.commentLines = [];
    this.captionTracks = [];
    this.captionLines2 = [];
    this.originalCaptionLines2 = [];
    this.selectedTracks = [];
    this.trackName = '';

    this.repeatA = NaN;
    this.repeatB = NaN;

    if (this.currentLineTimer) clearTimeout(this.currentLineTimer);
    this.currentLineTimer = null;

    if (this.bulletTimer) clearTimeout(this.bulletTimer);
    this.bulletTimer = null;

    this.currentLine = null;
    this.currentLineNum = 0;
    this.loading = false;
    this.error = null;

    this.noCaptions = false;
    this.currentTab = localStorage.getItem('last-man-tab') || 'CAPTION';

    this.ytb.bullets = [];

    this.videoInfo = null;
  }

  ngOnInit(): void {
    this.commentCtrl.valueChanges
      .pipe(debounceTime(200), distinctUntilChanged())
      .subscribe((comment: string) => {
        this.currentComment = comment;
      });

    this.searchService.searchText.subscribe((searchText) => {
      this.searchText = searchText;
      // console.log('search text changed: ', searchText);
      if (searchText) {
        this.lines.forEach((line) => {
          this.highlightSearchText(line);
        });
      }
    });
    this.searchService.isSearching.subscribe((isSearching) => {
      this.isSearching = isSearching;
      // console.log('isSearching: ', isSearching);
    });

    this.searchService.searchResultLanguage.subscribe((languageName) => {
      this.searchLanguageName = languageName;
    });

    this.socketService.socket.on('connect', () => {
      if (this.currentVid && !this.isSearching) {
        this.socketService.joinRoom(this.currentVid);
        this.getData();
      }
    });
    this.socketService.socket.on(
      'welcome',
      ({ asciiCat }) => (this.asciiCat = asciiCat)
    );
    this.socketService.socket.on('comment', (comment) => {
      // console.log('received comment: ', comment?.text);
      if (comment?.videoId === this.currentVid) {
        this.insertComment(comment);
      }
    });

    this.socketService.socket.on('error', (err) => {
      this.error = err;
    });

    this.initYtb();
    this.keyboardShortcuts();
  }

  async fetchCaptionsFromYtb(
    videoId: string,
    noCaptions = false,
    noRetry = false
  ) {
    const waitingTime = noCaptions ? 1000 : 10000;
    let waitingTimer;

    if (!(window as any).resolveCaptions) {
      window.addEventListener('message', (event) => {
        if (
          event.data?.type === 'captions' &&
          event.origin === 'https://www.youtube.com'
        ) {
          // console.log('recieved', event.data, event.origin);
          (window as any).resolveCaptions?.(event.data);
          clearTimeout(waitingTimer);
        } else if (
          event.data?.type === 'rawVideoData' &&
          event.origin === 'https://www.youtube.com'
        ) {
          // console.log('recieved raw videoData', event.data, event.origin);
          let videoData = event.data.videoData;
          if (typeof event.data.videoData === 'string') {
            videoData = eval(
              '(function() {return ' + event.data.videoData + '})();'
            );
          }

          $('#ytb-player')[0].contentWindow.postMessage(
            {
              type: noCaptions ? 'getVideoInfo' : 'getCaptions',
              videoId,
              videoLink: `https://www.youtube.com/watch?v=${videoId}`,
              noCaptions,
              videoData,
            },
            'https://www.youtube.com'
          );
        }
      });
    }

    return new Promise((resolve, reject) => {
      $('#ytb-player')[0].contentWindow.postMessage(
        {
          type: noCaptions ? 'getVideoInfo' : 'getCaptions',
          videoId,
          videoLink: `https://www.youtube.com/watch?v=${videoId}`,
          noCaptions,
          getRawVideoDataFirst: true,
        },
        'https://www.youtube.com'
      );

      (window as any).resolveCaptions = resolve;

      if (noRetry) {
        waitingTimer = setTimeout(reject, waitingTime);
      } else {
        waitingTimer = setTimeout(() => {
          // console.log('fetch from youtube timeout, retry...');
          this.fetchCaptionsFromYtb(videoId, noCaptions, true).then(
            resolve,
            reject
          );
        }, waitingTime);
      }
    });
  }

  async changeTab(name) {
    if (name === this.currentTab) return;
    this.currentTab = name;
    localStorage.setItem('last-man-tab', name);
    if (name === 'COMMENT') {
      this.lines = this.commentLines;
    } else {
      this.lines = this.captionLines;
    }
    await this.getData();
  }

  comment() {
    // console.log('comment: ', this.currentComment);
    if (!this.currentComment) return;

    const comment = {
      start: this.ytb.getCurrentTime() || 0,
      text: this.currentComment,
      username: this.username,
      userslug: this.userslug,
      videoId: this.currentVid,
    };

    this.socketService.socket.emit('message', comment);

    this.currentComment = '';
    this.commentCtrl.setValue('');
  }
  insertComment(comment) {
    const insertIdx = this.commentLines.findIndex(
      (line) => line.start > comment.start
    );
    if (insertIdx > -1) {
      this.commentLines.splice(insertIdx, 0, comment);
    } else {
      this.commentLines.push(comment);
    }
  }

  isSmallScreen() {
    return window.innerWidth < 768;
  }

  highlightSearchText(line: any) {
    if (!this.searchText) return;
    line.originalText = line.originalText || line.text;

    // Remove quote symbols and split into words
    const words = this.searchText
      .replace(/['"]/g, '') // Remove single and double quotes
      .split(/\s+/)
      .map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .filter(Boolean);

    if (!words.length) return;

    // Use lookbehind and lookahead for Unicode word boundaries
    // (?<!\p{L}) ensures the match is not preceded by a letter
    // (?!\p{L}) ensures the match is not followed by a letter
    const regex = new RegExp(
      `(?<!\\p{L})(${words.join('|')})(?!\\p{L})`,
      'giu'
    );

    line.text = line.originalText.replace(
      regex,
      (match) => `<span class="word-highlight">${match}</span>`
    );
  }

  genCaption2(newCaptions) {
    this.originalCaptionLines2 = newCaptions;
    this.captionLines2 = [];
    if (newCaptions.length === 0) return;

    let j: number = 0;

    const pushSameLines = (l: any, i: number) => {
      let l_next = this.lines[i + 1];
      let l2 = newCaptions[j];
      if (!l2) return;

      this.highlightSearchText(l2);

      if (!this.captionLines2[i]) this.captionLines2[i] = { texts: [] };

      if (l2.start <= l.start) {
        this.captionLines2[i].texts.push(l2.text);
        j += 1;
        pushSameLines(l, i);
      } else if (l2.start < l.start + l.dur) {
        if (!l_next || l2.start + l2.dur < l_next.start + l_next.dur / 2) {
          this.captionLines2[i].texts.push(l2.text);
          j += 1;
          pushSameLines(l, i);
        }
      } else {
        if (l_next && l2.start + l2.dur < l_next.start) {
          this.captionLines2[i].texts.push(l2.text);
          j += 1;
          pushSameLines(l, i);
        }
      }
    };
    this.lines.forEach((l, i) => {
      pushSameLines(l, i);
    });

    for (let index = j; index < newCaptions.length; index++) {
      this.captionLines2.push({ texts: [newCaptions[index].text] });
    }
  }

  async changeCaption(event, track) {
    if (!track?.languageName) {
      return;
    }

    const idx = this.selectedTracks.findIndex(
      (t) => t.languageName === track.languageName
    );
    if (idx >= 0) {
      this.selectedTracks.splice(idx, 1);
      if (idx === 0) {
        this.lines = this.originalCaptionLines2;
        this.lines.forEach((line) => {
          this.highlightSearchText(line);
        });
      }
      this.genCaption2([]);
    } else {
      this.loading = true;
      const videoId = this.currentVid;

      const captions = await this.socketService.asyncSend('getCaptions', {
        videoId,
        languageCode: track.languageCode,
        languageName: track.languageName,
      });

      if (videoId !== this.currentVid) return;

      const shouldReplaceTrack =
        event?.target &&
        event.target.nodeName !== 'INPUT' &&
        this.selectedTracks.length;

      if (shouldReplaceTrack) {
        // replace the track
        this.selectedTracks[this.selectedTracks.length - 1] = track;
      } else {
        this.selectedTracks.push(track);
      }

      if (this.selectedTracks.length === 3) {
        this.selectedTracks.splice(0, 1);
        this.lines = this.originalCaptionLines2;
        this.lines.forEach((line) => {
          this.highlightSearchText(line);
        });
        this.genCaption2(captions);
      } else if (this.selectedTracks.length === 2) {
        this.genCaption2(captions);
      } else {
        this.captionLines = captions;
        this.lines = captions;
        this.lines.forEach((line) => {
          this.highlightSearchText(line);
        });
      }
    }

    if (event?.target) {
      this.defaultLanguages = this.selectedTracks.map((t) => t.languageName);
      const savedStr_ = JSON.stringify(this.defaultLanguages);
      if (!savedStr_.includes('auto')) {
        // don't save auto-generated language as user preferred language
        localStorage.setItem('last-language-names', savedStr_);
      }
    }

    this.trackName = this.selectedTracks.map((t) => t.languageName).join(', ');
    this.loading = false;
  }

  fullscreen() {
    const $el = $('#ytb-player-container .fullscreen-wrapper');
    if ($el.hasClass('in-fullscreen')) {
      document.exitFullscreen();
    } else {
      $el[0].requestFullscreen();
    }
  }

  async getData() {
    if (this.loading) return;
    console.log('get data: ', this.currentVid);

    if (!this.videoInfo) {
      this.loading = true;
      this.videoInfo = await this.socketService.asyncSend('getVideoInfo', {
        videoId: this.currentVid,
      });
      this.loading = false;
    }

    if (!this.captionTracks.length) {
      this.loading = true;
      this.captionTracks = await this.socketService.asyncSend(
        'getCaptionTracks',
        {
          videoId: this.currentVid,
        }
      );
      this.loading = false;
      this.noCaptions = !this.captionTracks.length;
    }

    if (
      !this.commentLines.length &&
      (this.currentTab === 'COMMENT' || this.settings.bulletScreen)
    ) {
      this.loading = true;
      this.commentLines = await this.socketService.asyncSend('getComments', {
        videoId: this.currentVid,
      });
      this.loading = false;
      if (this.currentTab === 'COMMENT') {
        this.lines = this.commentLines;
      }

      this.genBullets();
    }

    if (this.currentTab === 'CAPTION' && !this.captionLines.length) {
      this.defaultLanguages = (() => {
        try {
          return JSON.parse(localStorage.getItem('last-language-names') || '');
        } catch (error) {
          return ['English', 'Swedish'];
        }
      })();

      for (const name of this.defaultLanguages) {
        const track =
          this.captionTracks.find((x) => x.languageName === name) ||
          this.captionTracks.find(
            (x) =>
              x.languageName.toLowerCase().includes(name.toLowerCase()) &&
              !x.languageName.toLowerCase().includes('auto')
          ) ||
          this.captionTracks.find((x) =>
            x.languageName.toLowerCase().includes(name.toLowerCase())
          );
        if (track) {
          await this.changeCaption(null, track);
        }
      }

      // add the search language if not in the selected tracks
      if (
        this.searchLanguageName &&
        !this.selectedTracks.find(
          (t) => t.languageName === this.searchLanguageName
        )
      ) {
        const track = this.captionTracks.find(
          (x) => x.languageName === this.searchLanguageName
        );
        if (track) {
          await this.changeCaption(null, track);
        }
      }

      if (!this.lines.length) {
        const findLang = (lang) => (x) =>
          x.languageName.toLowerCase().includes(lang.toLowerCase()) &&
          !x.languageName.toLowerCase().includes('auto');
        const defaultTrack =
          this.captionTracks.find(findLang('English')) ||
          this.captionTracks.find(findLang('Swedish')) ||
          this.captionTracks.find(findLang('Japanese')) ||
          this.captionTracks.find(findLang('Chinese')) ||
          this.captionTracks.find((x) => x.languageCode === 'en') ||
          this.captionTracks.find((x) => x.languageCode === 'en-US') ||
          this.captionTracks[0];
        await this.changeCaption(null, defaultTrack);
      } else {
        // waiting for angular render the lines.
        setTimeout(() => this.scrollToTime(this.ytb.getCurrentTime()));
      }
    }
  }

  genBullets() {
    if (!this.settings.bulletScreen) {
      return;
    }
    const t = this.ytb.getCurrentTime();
    clearTimeout(this.bulletTimer);
    this.commentLines.forEach((line) => {
      const diff = t - line.start;
      if (line.start <= t && diff < bulletDuration) {
        if (!line.yPos) {
          line.yPos = lineYposTracker + 1;
          const topPercent =
            ((line.yPos - 1) % 10) * 10 + Math.floor((line.yPos - 1) / 10);
          line.top = (this.playerHeight - 50) * topPercent * 0.01 + 'px';

          // console.log('push line: ', line);
          this.ytb.bullets.push(line);
          lineYposTracker += 1;
        }
      } else if (line.yPos) {
        const delIdx = this.ytb.bullets.findIndex((b) => b === line);
        delete line.yPos;
        this.ytb.bullets.splice(delIdx, 1);
      }
    });

    if (this.settings.bulletScreen) {
      this.bulletTimer = setTimeout(() => {
        this.genBullets();
      }, 2000);
    }
  }

  async initYtb() {
    this.ytb.videoId.subscribe(async (vid) => {
      if (!vid || this.isSearching) return;
      console.log('video id: ', vid);
      this.currentVid = vid;
      this.reset();

      this.socketService.socket.emit('joinRoom', {
        videoId: vid,
        manTab: this.currentTab,
      });
      await this.getData();

      this.hasDictionariezInstalled = $('.dictionaries-tooltip').length > 0;
      // console.log('hasDictionariezInstalled:', this.hasDictionariezInstalled);

      if (this.noCaptions && this.hasDictionariezInstalled) {
        this.loading = true;

        const parseXML = (xml: string) => {
          try {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xml, 'text/xml');
            const textNodes = xmlDoc.getElementsByTagName('text');
            const parsedData = Array.from(textNodes).map((textNode) => {
              const start = parseFloat(textNode.getAttribute('start') || '0');
              const dur = parseFloat(textNode.getAttribute('dur') || '1');
              const text = textNode.textContent;
              return { start, dur, text };
            });
            return parsedData;
          } catch (err) {
            console.error('Error parsing XML', err);
            return [];
          }
        };

        const result: any = await this.fetchCaptionsFromYtb(vid);
        if (result.videoId === vid && result.captions) {
          if (result.videoInfo) {
            await this.socketService.asyncSend(
              'handleVideoInfo',
              result.videoInfo
            );
            this.videoInfo = result.videoInfo;
          }

          if (result.captions.length === 0) {
            await this.socketService.asyncSend('downloadCaptions', {
              videoId: vid,
            });
          } else {
            await this.socketService.asyncSend('saveCaptions', {
              videoId: vid,
              captions: result.captions
                .map((caption) => {
                  if (caption.xml) {
                    caption.parsedCaptions = parseXML(caption.xml);
                  }
                  return caption;
                })
                .filter((c) => c.parsedCaptions),
              videoInfo: result.videoInfo,
            });
          }
          this.loading = false;
          await this.getData();
        }
        this.loading = false;
      } else if (!this.videoInfo && this.hasDictionariezInstalled) {
        this.loading = true;
        // console.log('need to get video info alone');
        const result: any = await this.fetchCaptionsFromYtb(vid, true).catch(
          () => {
            return {};
          }
        );
        // console.log('get info: ', result);
        if (result.videoId === vid && result.videoInfo) {
          await this.socketService.asyncSend(
            'handleVideoInfo',
            result.videoInfo
          );
          this.videoInfo = result.videoInfo;
        }
        this.loading = false;
      }
    });

    const setCaptionsHeight = () => {
      this.playerHeight = $('#ytb-player').height();
      if (!this.playerHeight) return;

      const h = $('#ytb-player').height() - 100;
      $('ul.caption-ul').css('height', `${h}px`);
      if (!this.isSmallScreen()) this.currentLineTop = (h * 2) / 5;
      else this.currentLineTop = 65;
    };

    setCaptionsHeight();
    new ResizeObserver(setCaptionsHeight).observe($('#ytb-player')[0]);
    window.addEventListener('resize', setCaptionsHeight.bind(this));
    this.changeFontSize(this.settings.fontSize);

    this.ytb.onStartPlaying = (t: number) => {
      if (this.lines.length) {
        console.log('on start playing: ', t);
        this.scrollToTime(t);
        this.genBullets();
      }
      clearTimeout(this.openShareTimer);
    };
    this.ytb.onPaused = () => {
      clearTimeout(this.currentLineTimer);
      this.currentLineTimer = null;

      const onDictionariez = location.search.includes('NO_REDIRECT=true');
      if (!this.openedShareBefore && !this.isSmallScreen() && !onDictionariez) {
        clearTimeout(this.openShareTimer);
        this.openShareTimer = setTimeout(() => {
          if (!this.ytb.playing) {
            $('app-shares .modal').modal('show');
            this.openedShareBefore = true;
          }
        }, 30000);
      }
    };
  }

  setLineTimer() {
    clearTimeout(this.currentLineTimer);

    const repeatLastLine = this.currentLineNum === this.repeatB;
    const lineDuration =
      this.currentTab === 'CAPTION' ? this.currentLine.dur : 1;

    let sec = this.currentLine.start + lineDuration - this.currentTime + 0.1;
    if (sec < 0.1) sec = 0.1;

    if (
      this.currentTab === 'COMMENT' &&
      this.currentTime < this.currentLine.start
    ) {
      sec = 1;
    } else {
      let nextLine = this.lines[this.currentLineNum + 1];
      if (nextLine && !repeatLastLine) {
        sec += (nextLine.start - (this.currentLine.start + lineDuration)) / 2;
        // console.log(`current: ${this.currentTime}, start: ${this.currentLine.start}, dur: ${this.currentLine.dur}, wait: ${sec}`);
      } else if (!nextLine && !repeatLastLine) {
        // console.log(`End of line, current: ${this.currentTime}`);
        this.currentLineTimer = null;
        return;
      }
    }

    // console.log('wait: ', sec, 'currentTime:', this.currentTime);
    this.currentLineTimer = setTimeout(() => {
      if (this.currentLineNum === this.repeatB) {
        // in repeat
        this.seekToLine(this.repeatA);
      } else {
        this.scrollToTime(this.ytb.getCurrentTime());
      }
    }, sec * 1000);
  }
  scrollToLine(idx) {
    if (this.currentLineNum >= 0) {
      $(
        `ul.caption-ul .list-group-item[data-index="${this.currentLineNum}"]`
      ).removeClass('active');
    }

    this.currentLine = this.lines[idx];
    this.currentLineNum = idx;

    // console.log('scroll to line: ', idx);

    if (this.currentLine) {
      // console.log(this.currentLine.text);
      if (this.ytb.playing) this.setLineTimer();

      if (this.repeatB >= 0 && !this.isLineInRepeat(this.currentLineNum)) {
        this.clearRepeat();
        this.cd.detectChanges(); // somehow, the changed didn't auto detected.
      }
      const $catpionUl = $('ul.caption-ul');
      const $el = $(
        `ul.caption-ul .list-group-item[data-index="${this.currentLineNum}"]`
      );
      $el.addClass('active');
      const el = $el[0];
      if (el) {
        if (this.settings.autoScrollMode === 'page') {
          const toolbarHeight = $('nav.top-nav').height();
          const elBottom = el.offsetTop + el.clientHeight - toolbarHeight;

          if (
            elBottom - $catpionUl.scrollTop() >= $catpionUl.height() ||
            elBottom < $catpionUl.scrollTop()
          ) {
            $('ul.caption-ul').scrollTop(el.offsetTop - toolbarHeight);
          }
        } else {
          $('ul.caption-ul').scrollTop(el.offsetTop - this.currentLineTop);
        }
      }
    }
  }
  scrollToTime(time: number) {
    const isLineInTime = (line, nextL) => {
      if (time <= line.start) {
        return true;
      } else if (nextL && time < nextL.start - 0.5) {
        return true;
      } else if (!nextL) {
        return true;
      }
      return false;
    };
    if (time == null) return;
    this.currentTime = time;
    const idx = this.lines.findIndex((l, i) =>
      isLineInTime(l, this.lines[i + 1])
    );
    if (idx > -1) this.scrollToLine(idx);
    this.genBullets();
  }

  seekToLine(i) {
    const line = this.lines[i];
    this.ytb.seekTo(line.start);

    this.currentTime = line.start;
    this.scrollToLine(i);
    this.genBullets();
  }

  clearRepeat() {
    this.repeatA = NaN;
    this.repeatB = NaN;
  }
  isLineInRepeat(i) {
    return (
      this.repeatA >= 0 &&
      this.repeatB >= 0 &&
      i >= this.repeatA &&
      i <= this.repeatB
    );
  }
  getRepeatLetter(i) {
    const isInABRepeat = this.repeatA >= 0 && this.repeatA !== this.repeatB;
    const onlyRepeatA = this.repeatA >= 0 && this.repeatA === this.repeatB;

    if (i === this.repeatB && isInABRepeat) return 'B';
    if (i !== this.repeatA && onlyRepeatA) return 'B';
    return 'A';
  }

  repeat(i) {
    // repeat a line
    const alreadyInRepeatA = this.repeatA >= 0 && this.repeatB === this.repeatA;
    if (i === this.repeatA || i === this.repeatB) {
      this.clearRepeat();
    } else if (alreadyInRepeatA) {
      this.repeatB = i;
      if (this.repeatB < this.repeatA) {
        this.repeatB = this.repeatA;
        this.repeatA = i;
      }

      if (
        this.currentLineNum > this.repeatB ||
        this.currentLineNum < this.repeatA
      ) {
        this.seekToLine(this.repeatA);
      }
    } else {
      this.repeatA = i;
      this.repeatB = i;
      this.seekToLine(i);
    }
  }
  openSettings() {
    $('app-settings .modal').modal('show');
  }
  changeFontSize(n) {
    $('ul.caption-ul').css('font-size', `${n}px`);
  }

  keyboardShortcuts() {
    const checkEditable = (el) => {
      return (
        el.isContentEditable ||
        ['input', 'textarea'].includes(el.nodeName.toLowerCase())
      );
    };
    $(document).bind('keydown', (event: KeyboardEvent) => {
      if (!event.altKey && !event.ctrlKey && !checkEditable(event.target)) {
        if (event.key === 'f') this.fullscreen();
        else if (event.key === 's') this.openSettings();
      }
    });
  }
  login() {
    if (location.hostname === 'localhost') {
      window.top.location.href = 'http://localhost:4567/login';
    } else {
      window.top.location.href = '/login?redirect=/captionz';
    }
    return false;
  }
}
